export default __webpack_public_path__ + "static/media/KOD0076-min.ddb7091c.webp";